module.exports = {"companySearchBoxTitle":"Wyszukaj firmę","companySearchBoxPlaceholder":"Warszawa","companySearchCompanyBoxPlaceholder":"Nazwa firmy","companyNameHeaderCaption":"Nazwa","companyCityHeaderCaption":"Miejscowość","companyStreetHeaderCaption":"Ulica","companyCodeHeaderCaption":"Akronim"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Company/translate.json
// module id = 430
// module chunks = 0